export default __webpack_public_path__ + "static/media/Whatsapp_qr_code.5989e054.jpg";